import { create } from "zustand";
import { StateType } from "./entities";
import { createCommonSlice } from "./slides";

export const useBoundStore = create<StateType>()((...a) => ({
  ...createCommonSlice(...a),
}));
